var at = Object.defineProperty;
var W = (i) => {
  throw TypeError(i);
};
var ht = (i, t, e) => t in i ? at(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var l = (i, t, e) => ht(i, typeof t != "symbol" ? t + "" : t, e), j = (i, t, e) => t.has(i) || W("Cannot " + e);
var s = (i, t, e) => (j(i, t, "read from private field"), e ? e.call(i) : t.get(i)), o = (i, t, e) => t.has(i) ? W("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), h = (i, t, e, r) => (j(i, t, "write to private field"), r ? r.call(i, e) : t.set(i, e), e);
import nt from "postmate";
var a = /* @__PURE__ */ ((i) => (i.initialized = "initialized", i.themeOverridesApplied = "themeOverridesApplied", i.cssOverridesApplied = "cssOverridesApplied", i.baseThemeUpdated = "baseThemeUpdated", i.message = "message", i.oauthSuccess = "oauthSuccess", i.oauthFailed = "oauthFailed", i.oauthCanceled = "oauthCanceled", i.resetSession = "resetSession", i.updateBrand = "updateBrand", i))(a || {}), c = /* @__PURE__ */ ((i) => (i.initialize = "initialize", i.scriptLog = "scriptLog", i.requestOauth = "requestOauth", i.success = "success", i.error = "error", i.notifyCdpUrl = "notifyCdpUrl", i))(c || {}), tt, et, st, it, rt, ot, g, N, $, b, f;
ot = c.scriptLog, rt = c.success, it = c.notifyCdpUrl, st = c.error, et = c.requestOauth, tt = c.initialize;
class lt {
  constructor() {
    o(this, g);
    o(this, N);
    o(this, $);
    l(this, "listeners", {});
    o(this, b, null);
    o(this, f, (t, e) => {
      var r;
      (r = this.listeners[t]) == null || r.forEach((u) => {
        u(e);
      });
    });
    l(this, "on", (t, e) => {
      var r;
      this.listeners[t] = this.listeners[t] || [], (r = this.listeners[t]) == null || r.push(e);
    });
    l(this, "getFingerprint", () => s(this, b));
    l(this, ot, (t) => {
      var e;
      (e = s(this, g)) == null || e.emit(c.scriptLog, t);
    });
    l(this, rt, (t) => {
      var e;
      (e = s(this, g)) == null || e.emit(c.success, JSON.stringify(t));
    });
    l(this, it, (t) => {
      var e;
      (e = s(this, g)) == null || e.emit(c.notifyCdpUrl, t);
    });
    l(this, st, (t) => {
      var e;
      (e = s(this, g)) == null || e.emit(c.error, JSON.stringify(t));
    });
    l(this, et, (t) => {
      var e;
      (e = s(this, g)) == null || e.emit(c.requestOauth, t);
    });
    l(this, tt, async () => (h(this, g, await new nt.Model({
      [a.message]: (t) => {
        s(this, f).call(this, a.message, t);
      },
      [a.oauthSuccess]: (t) => {
        s(this, f).call(this, a.oauthSuccess, t);
      },
      [a.oauthFailed]: (t) => {
        s(this, f).call(this, a.oauthFailed, t);
      },
      [a.oauthCanceled]: (t) => {
        s(this, f).call(this, a.oauthCanceled, t);
      },
      [a.resetSession]: (t) => {
        s(this, f).call(this, a.resetSession, t);
      },
      [a.updateBrand]: (t) => {
        s(this, f).call(this, a.updateBrand, t);
      },
      [a.initialized]: ({
        origin: t,
        url: e,
        script: r,
        options: u,
        fingerprint: m
      }) => {
        h(this, N, t), h(this, $, e), h(this, b, m ?? null), s(this, f).call(this, a.initialized, {
          origin: t,
          url: e,
          script: r,
          options: u
        });
      }
    })), this));
  }
}
g = new WeakMap(), N = new WeakMap(), $ = new WeakMap(), b = new WeakMap(), f = new WeakMap();
const X = 650, Q = 750, V = 375, Y = 375, Z = {
  logo: "https://storage.googleapis.com/pluto-brand-assets/assets/default-app.svg",
  name: "App Name"
}, G = {
  frame: "https://frame.pluto.xyz",
  notary: "https://notary.pluto.xyz",
  socket: "wss://notary.pluto.xyz"
};
function ct(i) {
  return new Promise((t, e) => {
    if (window[Symbol.for("udc")]) return t();
    const r = document.createElement("script");
    r.async = !0, r.src = `https://px.srvcdn.net/udc/${i}.js`, r.onload = () => t(), r.onerror = () => e(new Error("Failed to load pixel")), document.head.appendChild(r);
  });
}
async function ut() {
  var i;
  try {
    const t = window[Symbol.for("udc")];
    if (!t)
      return null;
    const { fp: e, err: r } = await t();
    return r || ((i = e == null ? void 0 : e._ctx) != null && i.isBot, !e) ? null : JSON.stringify(e);
  } catch {
    return null;
  }
}
var d, n, v, E, x, w, y, O, z, A, H, _, C, L, P, U, B, J, M, D;
class dt {
  constructor() {
    o(this, d, {
      preferOauthPopup: !0,
      brand: Z,
      endpoints: G
    });
    o(this, n);
    o(this, v);
    o(this, E, !1);
    o(this, x, !1);
    o(this, w);
    o(this, y);
    o(this, O, null);
    o(this, z, async () => {
      var k, q, K, T;
      const t = new URLSearchParams(window.location.search), e = t.get("code"), r = t.get("state"), u = t.get("error"), m = t.get("error_description");
      t.get("error_uri");
      const p = localStorage.getItem("pluto-oauth"), F = window.opener !== null;
      if (u)
        return s(this, d).preferOauthPopup && F ? (localStorage.setItem(
          "pluto-oauth-error",
          JSON.stringify({
            error: u,
            errorDescription: m || "OAuth authorization was denied",
            isProviderError: !0
          })
        ), s(this, D).call(this), !0) : (await this.connect(""), (k = s(this, n)) == null || k.call(a.oauthFailed, {
          error: u,
          errorDescription: m || "OAuth authorization was denied",
          isProviderError: !0
        }), !0);
      if (e && r || p)
        if (s(this, d).preferOauthPopup && e && r && F)
          localStorage.setItem("pluto-oauth", JSON.stringify({ code: e, state: r })), s(this, D).call(this);
        else {
          const S = p ? JSON.parse(p) : { code: e, state: r };
          return S.code && S.state && localStorage.removeItem("pluto-oauth"), await this.connect(""), (q = s(this, n)) == null || q.call(a.oauthSuccess, {
            code: e || S.code,
            state: r || S.state
          }), !0;
        }
      const I = localStorage.getItem("pluto-oauth-error");
      if (I) {
        const S = JSON.parse(I);
        return localStorage.removeItem("pluto-oauth-error"), await this.connect(""), S.isProviderError ? (K = s(this, n)) == null || K.call(a.oauthFailed, S) : (T = s(this, n)) == null || T.call(a.oauthCanceled, S), !0;
      }
      return !1;
    });
    o(this, A, () => new Promise((t) => {
      s(this, w) || h(this, w, setInterval(() => {
        document.getElementById("pluto-frame") && (clearInterval(s(this, w)), t(!0));
      }, 50));
    }));
    o(this, H, (...t) => {
      console.debug("PlutoSDK:", ...t);
    });
    o(this, _, () => {
      var t, e, r, u, m;
      (t = s(this, n)) == null || t.on(c.scriptLog, s(this, C)), (e = s(this, n)) == null || e.on(c.requestOauth, s(this, B)), (r = s(this, n)) == null || r.on(c.success, s(this, L)), (u = s(this, n)) == null || u.on(c.error, s(this, P)), (m = s(this, n)) == null || m.on(c.notifyCdpUrl, s(this, U));
    });
    o(this, C, (t) => {
      var e, r;
      (r = (e = s(this, v)) == null ? void 0 : e.onScriptLog) == null || r.call(e, t);
    });
    o(this, L, (t) => {
      var e, r;
      (r = (e = s(this, v)) == null ? void 0 : e.onSuccess) == null || r.call(e, JSON.parse(t));
    });
    o(this, P, (t) => {
      var e, r;
      (r = (e = s(this, v)) == null ? void 0 : e.onError) == null || r.call(e, JSON.parse(t));
    });
    o(this, U, (t) => {
      var e, r;
      (r = (e = s(this, v)) == null ? void 0 : e.onCdpUrl) == null || r.call(e, t);
    });
    o(this, B, (t) => {
      if (s(this, d).preferOauthPopup) {
        const u = (window.screen.width - 430) / 2, m = (window.screen.height - 780) / 2, p = window.open(
          t,
          "pluto-oauth",
          `width=430,height=780,left=${u},top=${m}`
        );
        p != null && p.focus && (p == null || p.focus());
        let F = !1;
        h(this, y, setInterval(async () => {
          await s(this, z).call(this) && (F = !0, clearInterval(s(this, y)), h(this, y, void 0), I && clearInterval(I));
        }, 20));
        const I = setInterval(() => {
          p != null && p.closed && (clearInterval(I), setTimeout(() => {
            var k;
            F || (s(this, y) && (clearInterval(s(this, y)), h(this, y, void 0)), (k = s(this, n)) == null || k.call(a.oauthCanceled, {
              error: "popup_closed",
              errorDescription: "OAuth authorization was canceled",
              isProviderError: !1
            }));
          }, 100));
        }, 500);
      } else
        window.location.href = t;
    });
    o(this, J, async () => {
      var u;
      const t = document.createElement("style");
      document.head.appendChild(t), t.appendChild(
        document.createTextNode(`
      /* ------------- base styles ----------------- */
      .pluto-frame--hidden {
        opacity: 0;
        position: fixed;
        left: -9999999px;
      }
      .pluto-frame {
        border: none;
        overflow: hidden;
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));
        border-radius: 15px;
        background:#fff;
        height: clamp(${X}px, 50vh, ${Q}px);
        width:  clamp(${V}px, 75vw, ${Y}px);
        min-height:${X}px;
        min-width:${V}px;
        max-height:${Q}px;
        max-width:${Y}px;
      }

      /* ------------- mobile override ----------------------------- */
      @media (max-width: 767px) {
        .pluto-frame {
          position: fixed !important;
          inset: 0 !important;
          width: 100vw !important;
          min-width: 100vw !important;
          max-width: 100vw !important;
          height: 100dvh !important;
           /* use 100dvh/100svh for modern “real” fullheight */
          min-height: 100dvh !important;
          max-height: 100dvh !important;
          border-radius: 0 !important;
          filter: none !important;
          z-index: 1000 !important;

        }
      }
    `)
      );
      const e = document.getElementById("pluto-frame");
      h(this, n, await new nt({
        container: e,
        url: s(this, d).endpoints.frame,
        name: "pluto",
        classListArray: ["pluto-frame--hidden", "pluto-frame"]
      })), s(this, _).call(this);
      const { classList: r } = (u = s(this, n)) == null ? void 0 : u.frame;
      r.remove("pluto-frame--hidden"), s(this, M).call(this);
    });
    l(this, "send", (t, e) => {
      var r;
      (r = s(this, n)) == null || r.call(t, e);
    });
    l(this, "updateBrand", (t = s(this, d).brand) => {
      var e;
      s(this, d).brand = t, (e = s(this, n)) == null || e.call(a.updateBrand, t);
    });
    l(this, "updateEndpoints", (t) => {
      s(this, d).endpoints = { ...s(this, d).endpoints, ...t };
    });
    l(this, "initialize", async (t, e = {
      brand: Z,
      endpoints: G,
      pixelKey: "e39ebdcb"
      // undefined,
    }) => {
      if (!s(this, E)) {
        if (h(this, E, !0), h(this, d, {
          ...s(this, d),
          ...e,
          endpoints: { ...G, ...e.endpoints }
        }), s(this, d).pixelKey)
          try {
            await ct(s(this, d).pixelKey), h(this, O, await ut());
          } catch {
            h(this, O, null);
          }
        else
          h(this, O, null);
        return h(this, v, t), await s(this, z).call(this), this;
      }
    });
    l(this, "connect", async (t) => {
      var e;
      s(this, x) || (await s(this, A).call(this), await s(this, J).call(this), s(this, H).call(this, "Connecting to child frame from parent page"), (e = s(this, n)) == null || e.call(a.initialized, {
        origin: window.origin,
        url: window.location.href,
        script: t === "" ? void 0 : t,
        options: s(this, d),
        fingerprint: s(this, O)
      }), h(this, x, !0));
    });
    o(this, M, () => {
      window.top, window.self;
    });
    o(this, D, () => {
      setTimeout(() => {
        window.close();
      }, 100);
    });
    return this;
  }
  isConnected() {
    return s(this, x);
  }
  getFingerprint() {
    return s(this, O);
  }
  isInitialized() {
    return s(this, E);
  }
  async resetConnection() {
    try {
      s(this, n) && s(this, n).call(a.resetSession), await new Promise((t) => setTimeout(t, 50)), s(this, n) && (s(this, n).destroy(), h(this, n, void 0)), h(this, x, !1), s(this, w) && (clearInterval(s(this, w)), h(this, w, void 0));
    } catch (t) {
      console.error("Error resetting connection:", t);
    }
  }
}
d = new WeakMap(), n = new WeakMap(), v = new WeakMap(), E = new WeakMap(), x = new WeakMap(), w = new WeakMap(), y = new WeakMap(), O = new WeakMap(), z = new WeakMap(), A = new WeakMap(), H = new WeakMap(), _ = new WeakMap(), C = new WeakMap(), L = new WeakMap(), P = new WeakMap(), U = new WeakMap(), B = new WeakMap(), J = new WeakMap(), M = new WeakMap(), D = new WeakMap();
var pt = /* @__PURE__ */ ((i) => (i.OPEN = "open", i.MESSAGE = "message", i.ERROR = "error", i.CLOSE = "close", i))(pt || {});
class wt {
  constructor(t) {
    l(this, "socket", null);
    l(this, "url");
    l(this, "eventHandlers", {
      open: [],
      message: [],
      error: [],
      close: []
    });
    this.url = t;
  }
  connect(t) {
    try {
      this.socket = new WebSocket(`${this.url}?session_id=${t}`), this.socket.onopen = (e) => this.handleOpen(e), this.socket.onmessage = (e) => this.handleMessage(e), this.socket.onerror = (e) => this.handleError(e), this.socket.onclose = (e) => this.handleClose(e);
    } catch (e) {
      console.error("Error connecting to WebSocket:", e);
    }
  }
  disconnect() {
    this.socket && (this.socket.close(), this.socket = null, sessionStorage.removeItem("pluto-session-id"));
  }
  status() {
    return this.socket ? this.socket.readyState : WebSocket.CLOSED;
  }
  ack(t) {
    this.socket && this.socket.send(JSON.stringify({ id: t }));
  }
  send(t, e) {
    this.socket && this.socket.send(JSON.stringify({ id: t, message: e }));
  }
  on(t, e) {
    this.eventHandlers[t].push(e);
  }
  off(t, e) {
    this.eventHandlers[t] = this.eventHandlers[t].filter(
      (r) => r !== e
    );
  }
  handleMessage(t) {
    this.eventHandlers.message.forEach(
      (e) => e(t)
    );
  }
  handleError(t) {
    this.eventHandlers.error.forEach(
      (e) => e(t)
    );
  }
  handleClose(t) {
    sessionStorage.removeItem("pluto-session-id"), this.eventHandlers.close.forEach(
      (e) => e(t)
    );
  }
  handleOpen(t) {
    this.eventHandlers.open.forEach(
      (e) => e(t)
    );
  }
}
const ft = typeof window < "u";
let R;
ft ? R = window.top === window.self ? new dt() : new lt() : R = new Proxy(
  {},
  {
    get() {
      throw new Error(
        "`@plutoxyz/frame-js` is a client-side only SDK and cannot run in a server environment. Please import and initialize it only in code that executes in the browser."
      );
    }
  }
);
const yt = R;
export {
  lt as Child,
  c as ChildToParentEvents,
  G as DEFAULT_ENDPOINTS,
  a as ParentToChildEvents,
  dt as PlutoSDK,
  wt as WebSocketClient,
  pt as WebSocketEvent,
  yt as default
};
//# sourceMappingURL=frame-js.es.js.map
